import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/Form/Button';
import App from 'modules/App';
import { SIGN_UP_FORM } from '../../../constants';
import * as selectors from '../../../selectors';
const Actions = ({ onBack, isContinueDisabled, stepValidatorRules })=>{
    const isInProgress = useSelector(selectors.isSignUpInProgress);
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const formValues = useSelector(App.selectors.formSelector(SIGN_UP_FORM));
    const validateWithErrorsDisplay = App.hooks.useFormProcessing(SIGN_UP_FORM);
    const onClickDisabled = ()=>{
        validateWithErrorsDisplay(formValues, stepValidatorRules);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "row flex-column-reverse flex-sm-row",
        children: [
            !isMobileDisplayMode && /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.back,
                    className: "btn--block",
                    onClick: onBack
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-12 col-sm-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    type: "submit",
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.signUp,
                    className: "btn--block btn--filled",
                    isDisabled: isContinueDisabled,
                    isInProgress: isInProgress,
                    onClickDisabled: onClickDisabled
                })
            })
        ]
    });
};
export default Actions;
